import { ArrowTooltip } from '@/components/arrow-tooltip.js';
import { TriangleAlert } from 'lucide-react';

interface ZoomNotStartedWarningProps {
  'data-testid'?: string;
}

export function ZoomNotStartedWarning({ 'data-testid': dataTestId }: ZoomNotStartedWarningProps) {
  return (
    <ArrowTooltip
      asChild
      trigger={
        <span
          className="inline-flex size-4 shrink-0 translate-y-px items-center justify-center leading-none"
          data-testid={dataTestId}
        >
          <TriangleAlert aria-hidden="true" className="block h-4 w-4 text-amber-500" />
          <span className="sr-only">Zoom meeting not started</span>
        </span>
      }
      position="bottom"
    >
      Zoom meeting not started
    </ArrowTooltip>
  );
}
